import React from 'react';
import { Handle, Position } from 'reactflow';
import { useTheme } from '../../../contexts/ThemeContext';
import { Play, Webhook, Clock } from 'lucide-react';

const TRIGGER_ICONS = {
  ManualTrigger: Play,
  WebhookTrigger: Webhook,
  ScheduleTrigger: Clock,
};

const TRIGGER_COLORS = {
  ManualTrigger: { bg: 'rgba(16,185,129,0.12)', border: '#10B981', icon: '#10B981' },
  WebhookTrigger: { bg: 'rgba(16,185,129,0.12)', border: '#10B981', icon: '#10B981' },
  ScheduleTrigger: { bg: 'rgba(16,185,129,0.12)', border: '#10B981', icon: '#10B981' },
};

export default function TriggerNode({ data, selected }) {
  const { isDark } = useTheme();
  const Icon = TRIGGER_ICONS[data.type] || Play;
  const colors = TRIGGER_COLORS[data.type] || TRIGGER_COLORS.ManualTrigger;

  const bg = colors.bg;
  const handleBg = isDark ? '#0d1117' : '#ffffff';
  const text1 = isDark ? '#e6edf3' : '#0f172a';
  const boxShadow = selected
    ? `0 0 0 3px rgba(248,114,23,0.25), 0 4px 16px ${isDark ? 'rgba(0,0,0,0.3)' : 'rgba(0,0,0,0.1)'}`
    : `0 2px 8px ${isDark ? 'rgba(0,0,0,0.25)' : 'rgba(0,0,0,0.06)'}`;

  return (
    <div
      style={{
        background: bg,
        border: `2px solid ${selected ? '#F87217' : colors.border}`,
        borderRadius: 12,
        padding: '10px 14px',
        minWidth: 160,
        boxShadow: boxShadow,
        transition: 'all 0.18s ease',
        cursor: 'default',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <div
          style={{
            width: 28,
            height: 28,
            borderRadius: 8,
            background: 'rgba(16,185,129,0.18)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <Icon size={14} color={colors.icon} />
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div
            style={{
              fontSize: 10,
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: '0.06em',
              color: colors.icon,
              marginBottom: 1,
            }}
          >
            Trigger
          </div>
          <div
            style={{
              fontSize: 12,
              fontWeight: 600,
              color: text1,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {data.label || data.type}
          </div>
        </div>
      </div>

      {/* Output handle */}
      <Handle
        type="source"
        position={Position.Right}
        style={{
          width: 10,
          height: 10,
          background: colors.icon,
          border: `2px solid ${handleBg}`,
          right: -6,
        }}
      />
    </div>
  );
}
